import api from "../axiosInstance";
import axios from "axios";

// Forgot password API (token-based)
export const forgotPasswordAPI = async (payload) => {
  try {
    const response = await api.post(
      process.env.REACT_APP_API_URL + "/api/v1/admin/auth/forgot-password",
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error : " + e.message);
    throw e;
  }
};

// Reset password API (code-based)
export const resetPasswordAPI = async (payload) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/api/v1/admin/auth/reset-password",
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error : " + e.message);
    throw e;
  }
};

